import { Component } from './Component';

export class Div extends Component {
	constructor(attribute, children) {
		super('div', attribute, children);
	}
}
